export default __webpack_public_path__ + "static/media/text_high.2a955907.svg";